<template>
  <div class="tickets">
    <div class="container">
      <ShadowTitle :title="`Выбери билет на шоу`"
                   title-shadow="TICKETS"/>

      <div class="row justify-content-center">
        <div class="col-12 col-md-7 col-lg-7 me-n1">
          <ul class="nav nav-pills" id="pills-tab" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link active" data-bs-toggle="pill" data-bs-target="#pills-guest"
                      type="button" role="tab" aria-controls="pills-guest" aria-selected="true">
                Для гостей
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" data-bs-toggle="pill" data-bs-target="#pills-inhabitant"
                      type="button" role="tab" aria-controls="pills-inhabitant" aria-selected="false">
                Для жителей ELS SPACE
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div class="tab-content" id="pills-tabContent">
        <div class="tab-pane fade show active" id="pills-guest" role="tabpanel" aria-labelledby="pills-guest-tab">
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="tickets-item">
                <div class="tickets-head">
                  <div class="tickets-title">
                    GUEST STANDARD
                  </div>
                  <div class="tickets-subtitle">
                    Для гостя
                  </div>
                  <div class="tickets-info">
                    Один день участия <br>в событии SPACE EVENT
                  </div>
                </div>
                <div class="tickets-body">
                  <ul class="tickets-list">
                    <li>доступ ко всем зонам мероприятия</li>
                    <li>кофе-брейки</li>
                    <li>фуршет</li>
                    <li>места в зале категории Standard</li>
                    <li>welcome-пакет участника Standard</li>
                    <li>фото и видео с мероприятия</li>
                  </ul>
                </div>
                <div class="tickets-footer">
                  <!--                  <div class="d-flex flex-wrap justify-content-between mb-3 ">-->
                  <!--                    <div class="tickets-price">-->
                  <!--                      19 990 ₽-->
                  <!--                    </div>-->
                  <!--                    <div class="tickets-info">-->
                  <!--                      Билет можно <br>купить в рассрочку-->
                  <!--                      <img class="img-fluid ms-2"-->
                  <!--                           :src="require(`@/assets/percent.svg`)"-->
                  <!--                           alt="Билет можно купить в рассрочку"-->
                  <!--                      >-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <!--                  <GlobalButton-->
                  <!--                      data-bs-toggle="modal"-->
                  <!--                      data-bs-target="#FormBuyTicket"-->
                  <!--                      @click.prevent="setTariffId('standard')"-->
                  <!--                  >-->
                  <!--                    Купить билет-->
                  <!--                  </GlobalButton>-->
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="tickets-item _second">
                <div class="tickets-head">
                  <div class="tickets-title">
                    GUEST VIP
                  </div>
                  <div class="tickets-subtitle">
                    Для гостя
                  </div>
                  <div class="tickets-info">
                    Один день участия <br>в событии SPACE EVENT
                  </div>
                </div>
                <div class="tickets-body">
                  <ul class="tickets-list">
                    <li>доступ ко всем зонам мероприятия</li>
                    <li>кофе-брейки</li>
                    <li>фуршет</li>
                    <li>обед в ресторане «Матрешка» <br>с основателем и Героями пространства <br>ELS SPACE</li>
                    <li>трансфер «Бородино-Матрешка-Бородино»</li>
                    <li>места в зале категории VIP</li>
                    <li>welcome-пакет участника VIP</li>
                    <li>фото и видео с мероприятия</li>
                  </ul>
                </div>
                <div class="tickets-footer">
                  <!--                  <div class="d-flex flex-wrap justify-content-between mb-3">-->
                  <!--                    <div class="tickets-price">-->
                  <!--                      25 990 ₽-->
                  <!--                    </div>-->
                  <!--                    <div class="tickets-info">-->
                  <!--                      Билет можно <br>купить в рассрочку-->
                  <!--                      <img class="img-fluid ms-2"-->
                  <!--                           :src="require(`@/assets/percent.svg`)"-->
                  <!--                           alt="Билет можно купить в рассрочку"-->
                  <!--                      >-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <!--                  <GlobalButton-->
                  <!--                      class="_disabled"-->
                  <!--                      data-bs-toggle="modal"-->
                  <!--                      data-bs-target="#FormBuyTicket"-->
                  <!--                      @click.prevent="setTariffId('vip')"-->
                  <!--                  >-->
                  <!--                    Все билеты распроданы!-->
                  <!--                  </GlobalButton>-->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="pills-inhabitant" role="tabpanel" aria-labelledby="pills-inhabitant-tab">
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="tickets-item _vip">
                <div class="tickets-head">
                  <div class="tickets-title">
                    STANDARD
                  </div>
                  <div class="tickets-subtitle">
                    Для жителя ELS SPACE
                  </div>
                  <div class="tickets-info">
                    Два дня участия <br>в событии SPACE EVENT
                  </div>
                </div>
                <div class="tickets-body">
                  <ul class="tickets-list">
                    <li>доступ ко всем зонам мероприятия</li>
                    <li>кофе-брейки</li>
                    <li>фуршет</li>
                    <li>места в зале категории Standard</li>
                    <li>welcome-пакет участника Standard</li>
                    <li>фото и видео с мероприятия</li>
                  </ul>
                </div>
                <div class="tickets-footer">
                  <!--                  <div class="d-flex flex-wrap justify-content-between mb-3">-->
                  <!--                    <div class="tickets-price">-->
                  <!--                      27 990 ₽-->
                  <!--                    </div>-->
                  <!--                    <div class="tickets-info">-->
                  <!--                      Билет можно <br>купить в рассрочку-->
                  <!--                      <img class="img-fluid ms-2"-->
                  <!--                           :src="require(`@/assets/percent.svg`)"-->
                  <!--                           alt="Билет можно купить в рассрочку"-->
                  <!--                      >-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <!--                  <GlobalButton data-bs-toggle="modal"-->
                  <!--                                data-bs-target="#ModalRedirect"-->
                  <!--                  >-->
                  <!--                    Купить билет-->
                  <!--                  </GlobalButton>-->
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="tickets-item _second _vip">
                <div class="tickets-head">
                  <div class="tickets-title">
                    VIP
                  </div>
                  <div class="tickets-subtitle">
                    Для жителя ELS SPACE
                  </div>
                  <div class="tickets-info">
                    Два дня участия <br>в событии SPACE EVENT
                  </div>
                </div>
                <div class="tickets-body">
                  <ul class="tickets-list">
                    <li>доступ ко всем зонам мероприятия</li>
                    <li>кофе-брейки</li>
                    <li>фуршет</li>
                    <li>обеды в ресторанах с основателем <br>и Героями пространства ELS SPACE</li>
                    <li>трансфер «Бородино-Матрешка-Бородино»</li>
                    <li>места в зале категории VIP</li>
                    <li>welcome-пакет участника VIP</li>
                    <li>фото и видео с мероприятия</li>
                  </ul>
                </div>
                <div class="tickets-footer">
                  <!--                  <div class="d-flex flex-wrap justify-content-between mb-3">-->
                  <!--                    <div class="tickets-price">-->
                  <!--                      32 990 ₽-->
                  <!--                    </div>-->
                  <!--                    <div class="tickets-info">-->
                  <!--                      Билет можно <br>купить в рассрочку-->
                  <!--                      <img class="img-fluid ms-2"-->
                  <!--                           :src="require(`@/assets/percent.svg`)"-->
                  <!--                           alt="Билет можно купить в рассрочку"-->
                  <!--                      >-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <!--                  <GlobalButton class="_disabled"-->
                  <!--                                data-bs-toggle="modal"-->
                  <!--                                data-bs-target="#ModalRedirect"-->
                  <!--                  >-->
                  <!--                    Все билеты распроданы!-->
                  <!--                  </GlobalButton>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ShadowTitle from "@/components/ShadowTitle";
import GlobalButton from "@/components/GlobalButton";
import {useStore} from "vuex";

export default {
  name: "Tickets",
  components: {GlobalButton, ShadowTitle},
  setup() {
    const store = useStore();

    const setTariffId = (tariff) => {
      store.dispatch('chooseTariff', tariff);
    }

    return {
      setTariffId
    }
  }
}
</script>
<style lang="scss" scoped>
.sold-out {
  font-family: Play, serif;
  font-size: 24px;
  font-weight: 600;
  color: #ED2D35;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
}

.nav.nav-pills {
  border-radius: 160px;
  background: var(--deep-dark, #1B1B21);
  box-shadow: 0 4px 22px 0 rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  padding: 12px;
  margin-bottom: 18px;
  @include _768 {
    margin-bottom: 80px;
  }

  .nav-item {
    width: 50%;
    display: flex;

    .nav-link {
      color: var(--White, #FFF);
      text-align: center;
      font-family: Play, serif;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 138%;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      border-radius: 220px;
      @include _768 {
        font-size: 22px;
        padding: 18px;
      }

      &.active {
        background: var(--White, #FFF);
        color: var(--deep-dark, #1B1B21);
      }
    }
  }
}

.tickets-item {
  border-radius: 16px;
  background: linear-gradient(174deg, rgba(255, 255, 255, 0.20) 0%, rgba(0, 0, 0, 0.00) 9.37%), #0D0D10;
  box-shadow: 0 4px 76px 0 rgba(0, 0, 0, 0.60);
  padding: 24px 18px 36px;
  display: flex;
  flex-direction: column;
  height: 100%;

  &._second {
    background: radial-gradient(162.35% 128.82% at 0% 0%, #2002DB 0%, rgba(0, 0, 0, 0.00) 100%), linear-gradient(174deg, rgba(255, 255, 255, 0.20) 0%, rgba(0, 0, 0, 0.00) 9.37%), #0D0D10;

    .global-button {
      background: var(--btn-normal, linear-gradient(92deg, #C0F -7.4%, #010BFE 102.31%));
      color: white;
    }
  }

  &._vip {
    .tickets-subtitle {
      padding: 4px 8px;
      border-radius: 50px;
      background: var(--btn-normal, linear-gradient(92deg, #C0F -7.4%, #010BFE 102.31%));
      margin-right: auto;
      color: var(--white, #FFF);
      font-size: 18px;
    }

    .tickets-head {
      .tickets-info {
        border: 1px solid var(--blue, #010BFE);
      }
    }
  }

  @include _768 {
    padding: 44px 56px;
  }

  .tickets-head {
    display: flex;
    flex-direction: column;
    margin-bottom: 12px;
    @include _768 {
      margin-bottom: 16px;
    }
  }

  .tickets-body {
    margin-bottom: 20px;
  }

  .tickets-footer {
    margin-top: auto;
  }

  .tickets-title {
    font-family: Play, serif;
    font-size: 38px;
    font-style: normal;
    font-weight: 700;
    line-height: 116%; /* 44.08px */
    margin-bottom: 16px;
    @include _768 {
      font-size: 44px;
    }
  }

  .tickets-subtitle {
    color: var(--gray, #C7C7D1);
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 136%; /* 24.48px */
    margin-bottom: 16px;
    @include _768 {
      font-size: 20px;
    }
  }

  .tickets-head {
    .tickets-info {
      color: var(--white, #FFF);
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 128%; /* 20.48px */
      padding: 14px 28px;
      border-radius: 8px;
      border: 1px solid var(--dark-gray, #37373C);
    }
  }

  .tickets-list {
    padding-left: 1rem;
    margin-bottom: 0;
    color: var(--gray, #C7C7D1);
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 136%; /* 24.48px */
    @include _768 {
      font-size: 22px;
    }

    li {
      margin-bottom: 12px;
      @include _768 {
        margin-bottom: 16px;
      }
    }
  }

  .tickets-footer {
    display: flex;
    flex-direction: column;

    .tickets-info {
      border-radius: 8px;
      background: linear-gradient(95deg, #0A1A6B 2.09%, #282A30 110.4%);
      backdrop-filter: blur(2px);
      padding: 2px 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 128%; /* 15.36px */
      margin-left: auto;
      @include _768 {
        font-size: 16px;
        padding: 2px 12px;
      }
    }
  }

  .tickets-price {
    color: var(--white, #FFF);
    font-family: Play, serif;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 128%;
    @include _768 {
      font-size: 38px;
      line-height: 116%;
    }
  }
}
</style>
